import React from 'react';
import './Certificates.css';

const Certificates = () => {
    const certificates = [
        {
            id: 1,
            title: 'Bachelor of Science',
            institution: 'University of Arizona Global Campus',
            field: 'Information Technology',
            date: 'August 25, 2025',
            image: '/certificates/certificate_1.jpeg',
            description: 'Comprehensive degree program covering advanced IT concepts, systems design, and technology management.',
            honors: 'Magna Cum Laude'
        },
        {
            id: 2,
            title: 'Associate in Arts',
            institution: 'Strayer University',
            field: 'Information Technology',
            date: 'December 19, 2022',
            image: '/certificates/certificate_2.jpeg',
            description: 'Foundation degree focused on core IT principles, programming, and network fundamentals.',
            honors: 'Honors Scholar'
        }
    ];

    return (
        <div className="certificates-page">
            {/* Hero Section */}
            <section className="certificates-hero">
                <div className="container">
                    <h1 className="page-title fade-in">Professional Certifications</h1>
                    <p className="page-subtitle fade-in">
                        Demonstrating commitment to excellence through formal education and professional development
                    </p>
                </div>
            </section>

            {/* 🎓 Professional Achievement Section */}
            <section className="certificates-intro section">
                <div className="container">
                    <div className="intro-content">
                        <h2 className="section-title">Academic Excellence in Technology</h2>
                        <p className="intro-text">
                            Our team's educational foundation combines rigorous academic training with hands-on
                            technical expertise. These credentials represent years of dedicated study in information
                            technology, systems architecture, and network security—directly translating to the
                            high-quality surveillance and security solutions we deliver to our clients.
                        </p>
                    </div>
                </div>
            </section>

            {/* Certificates Grid */}
            <section className="certificates-grid-section section">
                <div className="container">
                    <div className="certificates-grid">
                        {certificates.map((cert) => (
                            <div key={cert.id} className="certificate-card">
                                <div className="certificate-image-wrapper">
                                    <img
                                        src={cert.image}
                                        alt={`${cert.title} from ${cert.institution}`}
                                        className="certificate-image"
                                    />
                                    <div className="certificate-overlay">
                                        <span className="view-text">🔍 Click to View Full Certificate</span>
                                    </div>
                                </div>

                                <div className="certificate-details">
                                    <div className="certificate-header">
                                        <h3 className="certificate-title">{cert.title}</h3>
                                        {cert.honors && (
                                            <span className="certificate-honors">🏆 {cert.honors}</span>
                                        )}
                                    </div>

                                    <div className="certificate-meta">
                                        <p className="certificate-institution">
                                            <span className="meta-icon">🎓</span>
                                            {cert.institution}
                                        </p>
                                        <p className="certificate-field">
                                            <span className="meta-icon">💻</span>
                                            {cert.field}
                                        </p>
                                        <p className="certificate-date">
                                            <span className="meta-icon">📅</span>
                                            Graduated: {cert.date}
                                        </p>
                                    </div>

                                    <p className="certificate-description">{cert.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Trust & Credibility Section */}
            <section className="credibility-section section">
                <div className="container">
                    <div className="credibility-content">
                        <h2 className="section-title">Why Our Credentials Matter</h2>
                        <div className="credibility-grid">
                            <div className="credibility-item">
                                <div className="credibility-icon">🔒</div>
                                <h3>Technical Expertise</h3>
                                <p>Formal training in IT systems, network security, and infrastructure design ensures we implement industry best practices.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">✅</div>
                                <h3>Quality Assurance</h3>
                                <p>Academic rigor translates to meticulous attention to detail in every surveillance system installation.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">🎯</div>
                                <h3>Continuous Learning</h3>
                                <p>Our commitment to education means we stay current with emerging security technologies and methodologies.</p>
                            </div>
                            <div className="credibility-item">
                                <div className="credibility-icon">🤝</div>
                                <h3>Professional Standards</h3>
                                <p>Certified professionals bring accountability and adherence to ethical standards in all client engagements.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Certificates;
